import * as Wildfire from "../../layers/static/Wildfire";

import base, { Config, StaticMapLayerOrFolder } from "../../config";
import {
  camerasAZGF,
  camerasPima,
  camerasPinal,
  camerasSantaCruz,
} from "../../layers/misc/cameras";

import FEMA_NFHL from "../../layers/dynamic/FEMA_NFHL";
import { LatLng } from "leaflet";
import disclaimer from "./disclaimer";
import notEmpty from "../../shared/notEmpty";

const staticLayers: StaticMapLayerOrFolder[] = [
  Wildfire.last(3),
  {
    source: process.env.PUBLIC_URL + "/kml/Arizona_Counties.kml",
    name: "County Boundary",
  },
  {
    source: process.env.PUBLIC_URL + "/kml/Arizona_Municipal.kml",
    name: "Municipal Boundary",
  },
  {
    source: process.env.PUBLIC_URL + "/kml/Watershed.kml",
    name: "Watersheds",
  },
  {
    source: process.env.PUBLIC_URL + "/kml/Inundation_Washes.kml",
    name: "Major Watercourses",
  },
  {
    source: process.env.PUBLIC_URL + "/kml/PimaWashes2k.kml",
    name: "Washes",
  },
].filter(notEmpty);

const config: Config = {
  ...base,
  ...{
    title: "Pima County ALERT",
    center: new LatLng(32.222288, -110.983392),
    zoom: 10,
    basemap: "Topographic",
    disclaimer,
    agencyPassList: [
      "Pima County Regional Flood Control District",
      "United States Geological Survey",
      "Santa Cruz County Flood Control District",
      "Cochise County",
      "Pinal County Flood Control District",
      "Arizona Game and Fish Department",
    ],
    layers: {
      static: staticLayers,
      dynamic: [FEMA_NFHL],
      misc: [
        {
          title: "Webcams",
          layers: [
            { name: "Pima County", cameras: camerasPima },
            { name: "Pinal County", cameras: camerasPinal },
            { name: "Santa Cruz County", cameras: camerasSantaCruz },
            { name: "Arizona Game and Fish Department", cameras: camerasAZGF },
          ],
        },
      ],
      lightning: true,
      cbrfc: false, 
    },
  },
};

export default config;
